import moment from 'moment';
import { compose, ifElse, path, split, test, when } from 'ramda';
import { isNotNil, isNotNilOrEmpty } from '@@serverHelpers/index.mjs';

export const FORMAT_DATE_FR = 'DD/MM/YYYY';
export const FORMAT_DATE_SYSTEM = 'YYYY-MM-DD';

export const maybeParseInt = when(test(/[0-9]+/), parseInt);

export const dateTsToFr = (value) => moment(maybeParseInt(value)).format(FORMAT_DATE_FR);
export const dateTsToDate = (value) => moment(maybeParseInt(value)).toDate();
export const tsToSystem = (value) => moment(maybeParseInt(value)).format(FORMAT_DATE_SYSTEM);
export const isoToFr = (value) => moment(value).format(FORMAT_DATE_FR);
export const tsToDateObj = (timestamp) => new Date(parseInt(timestamp));

const datePathTsConverter = (paths, obj, convertFunction) =>
  compose(when(isNotNil, convertFunction), path(split('.', paths)))(obj);

export const datePathTsToFr = (paths, obj) => datePathTsConverter(paths, obj, dateTsToFr);

export const dateTimeToMidday = (date) => moment(date).startOf('day').hour(12).minute(0);

export const minEffectDate = () => moment().startOf('D').add(1, 'day');

export const dateTsToSystem = ifElse(isNotNilOrEmpty, tsToSystem, () => null);
